/* eslint-disable react/no-unknown-property */
import { useContext, useEffect, useState } from 'react';

import getGDPRRegion from '../../../services/ipInfo.service';
import ComplianzBanner from './ComplianzBanner';
import initComplianz from './initComplianz';
import { AppConstantsContext } from '../../../context';

const ComplianzCookieConsent = () => {
  const { crossDomains, gaTrackingId, isMusehub } = useContext(AppConstantsContext);
  const [region, setRegion] = useState<string | null>(null);
  const [loadTracking, setLoadTracking] = useState(false);
  const [cssLoaded, setCssLoaded] = useState(false);

  useEffect(() => {
    const getRegion = async () => {
      const reg = await getGDPRRegion();
      setRegion(reg);
    };
    if (!region) {
      getRegion();
    }
  });

  useEffect(() => {
    if (region) {
      setTimeout(() => {
        // complianz.min.js should load after html finished banner rendering
        initComplianz(region);
      }, 600);
    }
  }, [region]);

  useEffect(() => {
    if (!loadTracking) {
      const interval = setInterval(() => {
        if (
          document.cookie.includes('cmplz_marketing=allow')
          && document.cookie.includes('cmplz_statistics=allow')
        ) {
          setLoadTracking(true);
          clearInterval(interval);
        }
      }, 1500);
    }
  }, [loadTracking]);

  useEffect(() => {
    const interval = setInterval(() => {
      const myCSS = document.querySelector(
        "link[href*='https://klang.io/wp-content/uploads/complianz/css/banner']",
      );
      if (myCSS) {
        setCssLoaded(true);
        clearInterval(interval);
      }
    }, 1500);
  }, []);

  useEffect(() => {
    if (!loadTracking) return;

    // 1. gtag.js laden
    const gtagScript = document.createElement('script');
    gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${gaTrackingId}`;
    gtagScript.async = true;
    document.head.appendChild(gtagScript);

    // 2. gtag initialisieren
    const inlineScript = document.createElement('script');
    inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('set', 'linker', {
        'domains': [${crossDomains}]
      });
      gtag('js', new Date());
      gtag('config', '${gaTrackingId}', {
        anonymize_ip: true,
        page_path: window.location.pathname,
      });
    `;
    document.head.appendChild(inlineScript);

    // 3. GTM laden
    const gtmScript = document.createElement('script');
    gtmScript.innerHTML = `
         (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-5BMJSHP');`;
    document.head.appendChild(gtmScript);

    // 4. TD Conversion Object laden
    const tdScript = document.createElement('script');
    tdScript.id = 'tradedoubler';
    tdScript.innerHTML = `
      (function(i,s,o,g,r,a,m){i['TDConversionObject']=r;i[r]=i[r]||function(){(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)})(window,document,'script', 'https://svht.tradedoubler.com/tr_sdk.js?org=2310890&prog=325973&dr=true&rand=' + Math.random(), 'tdconv');
    `;
    document.head.appendChild(tdScript);
  }, [loadTracking, gaTrackingId, crossDomains]);

  return (
    !isMusehub && (
      <>
        {/* load banner but do not show it before css is loaded */}
        <div data-cmplz="1" style={{ display: cssLoaded ? 'inherit' : 'none' }}>
          <ComplianzBanner />
        </div>
      </>
    )
  );
};
export default ComplianzCookieConsent;
